/* LiverComplex - comportamientos propios tras salir de Zipify Pages.
   Cubre lo que antes hacia fr-page-published-scripts.min.js:
   acordeon de FAQ, carruseles de producto y contadores evergreen. */
(function () {
  'use strict';

  var root = document.querySelector('.zpn-liver-omar');
  if (!root) return;

  /* ------------------------------------------------------- acordeon FAQ */
  function initAccordion() {
    var headers = root.querySelectorAll('[data-faq-header]');
    Array.prototype.forEach.call(headers, function (header) {
      var item = header.closest('[data-faq-item]');
      if (!item) return;

      function toggle(e) {
        if (e) e.preventDefault();
        var open = item.classList.toggle('zpa-accordion__item--active');
        header.setAttribute('aria-expanded', open ? 'true' : 'false');
      }

      header.addEventListener('click', toggle);
      header.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') toggle(e);
      });
    });
  }

  /* ------------------------------------------------ carrusel de producto */
  function initCarousel(wrapper) {
    var track = wrapper.querySelector('[data-carousel]');
    if (!track) return;

    var slides = track.querySelectorAll('[data-img-carousel-wrapper]');
    if (slides.length === 0) return;

    var prev = wrapper.querySelector('[data-prev-img-btn]');
    var next = wrapper.querySelector('[data-next-img-btn]');
    var thumbs = wrapper.querySelectorAll('[data-media-icon]');
    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;
      Array.prototype.forEach.call(slides, function (s, n) {
        s.style.display = n === index ? '' : 'none';
      });
      Array.prototype.forEach.call(thumbs, function (t, n) {
        t.classList.toggle('active', n === index);
      });
    }

    /* con una sola imagen las flechas sobran */
    if (slides.length > 1) {
      if (prev) prev.classList.remove('hidden');
      if (next) next.classList.remove('hidden');
    }
    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    Array.prototype.forEach.call(thumbs, function (t, n) {
      t.addEventListener('click', function () { show(n); });
    });

    show(0);
  }

  /* --------------------------------------------- contadores evergreen */
  function initCountdown(el) {
    var span = parseInt(el.getAttribute('data-value'), 10);
    if (!span || span <= 0) return;

    /* viene oculto en el markup: Zipify lo revelaba al arrancar la cuenta */
    el.classList.remove('hidden');

    /* evergreen: la cuenta arranca en la primera visita y se recuerda */
    var key = 'zpn-liver-deadline-' + (el.getAttribute('data-count-time-version') || '1');
    var deadline = parseInt(window.localStorage.getItem(key), 10);
    var now = Date.now();
    if (!deadline || isNaN(deadline) || deadline < now) {
      deadline = now + span;
      try { window.localStorage.setItem(key, String(deadline)); } catch (err) { /* modo privado */ }
    }

    var cluster = el.closest('[data-countdown-cluster]') || el;
    var out = {
      days: cluster.querySelector('[data-days]'),
      hours: cluster.querySelector('[data-hours]'),
      minutes: cluster.querySelector('[data-minutes]'),
      seconds: cluster.querySelector('[data-seconds]')
    };

    function pad(n) { return n < 10 ? '0' + n : String(n); }

    /* la original esconde el bloque de dias cuando faltan menos de 24h */
    var daysWrapper = cluster.querySelector('[data-days-wrapper]');

    function tick() {
      var left = Math.max(0, deadline - Date.now());
      var s = Math.floor(left / 1000);
      var parts = {
        days: Math.floor(s / 86400),
        hours: Math.floor((s % 86400) / 3600),
        minutes: Math.floor((s % 3600) / 60),
        seconds: s % 60
      };
      Object.keys(out).forEach(function (k) {
        if (out[k]) out[k].textContent = pad(parts[k]);
      });
      if (daysWrapper) daysWrapper.style.display = parts.days > 0 ? '' : 'none';
      if (left <= 0) clearInterval(timer);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  /* ------------------------------------------------- lazyload de iframes */
  /* Zipify dejaba los videos de Vimeo con data-src y sin src; el que los
     promovia al entrar en pantalla era fr-page-published-scripts.min.js.
     Acotado a .zpa-lazyload dentro de la seccion: el theme tiene su propio
     lazyload (lazyloadt4s) para logo e imagenes de producto, y no se toca. */
  function loadLazy(el) {
    var src = el.getAttribute('data-src');
    if (!src || el.getAttribute('src') === src) return;
    el.setAttribute('src', src);
    el.classList.remove('zpa-lazyload');
  }

  function sweepLazy() {
    Array.prototype.forEach.call(
      root.querySelectorAll('.zpa-lazyload[data-src]'), loadLazy);
  }

  function initLazy() {
    sweepLazy();

    /* Algo vuelve a dejar estos iframes en lazy despues del load, y con el
       src apuntando a la propia landing (se cargaba la pagina dentro de si
       misma y el bloque salia en blanco). Por eso no basta una sola pasada:
       se vuelve a barrer ante cualquier cambio dentro de la seccion. */
    if (!('MutationObserver' in window)) return;
    var pendiente = null;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = setTimeout(function () { pendiente = null; sweepLazy(); }, 150);
    }).observe(root, { childList: true, subtree: true, attributes: true,
                       attributeFilter: ['src', 'data-src', 'class'] });
  }

  function init() {
    initLazy();
    initAccordion();
    Array.prototype.forEach.call(
      root.querySelectorAll('.zpa-el-shopify-product-carousel'), initCarousel);
    Array.prototype.forEach.call(
      root.querySelectorAll('[data-count-down]'), initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('load', sweepLazy);
})();
